module.exports = __webpack_public_path__ + "img/bench-tree.e439390c.svg";